import { trpc } from '@/shared/api';

/**
 * 후기 목록·상세를 다시 불러오게 한다. 열린 상세를 다시 불러오면 개인정보 조회 기록이 하나 더 남지만,
 * 숨김 직후 상세 갱신에 필요한 기록이므로 허용한다.
 */
export const useInvalidateReviews = (): (() => void) => {
  const utils = trpc.useUtils();
  return () => {
    void utils.reviewManagement.list.invalidate();
    void utils.reviewManagement.get.invalidate();
  };
};
